import {rtkQueryApi} from '~/shared/api/rtk-query-api';
import {buildFiltersParams} from '~/shared/utils/buildFiltersParams';
import {IPagination} from '../types/types';

export const templatesApi = rtkQueryApi
  .enhanceEndpoints({
    addTagTypes: ['accounts', 'templates'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getTemplateCampaign: builder.query<IPagination, any>({
        query: ({page, pageSize, search, filters}) => {
          const params = new URLSearchParams();

          params.set('page', String(page));
          params.set('page_size', String(pageSize));
          if (search?.trim()) {
            params.set('search', search.trim());
          }
          const filtersParams = buildFiltersParams(filters || {});

          return {
            url: `/campaign/template?${params.toString()}&${filtersParams}`,
            method: 'GET',
          };
        },
        providesTags: ['templates'],
        transformResponse: res => res as IPagination,
      }),
      getAllTemplateCampaign: builder.query<IPagination, any>({
        query: ({page, pageSize, search, filters}) => {
          const params = new URLSearchParams();

          params.set('page', String(page));
          params.set('page_size', String(pageSize));
          if (search?.trim()) {
            params.set('search', search.trim());
          }
          const filtersParams = buildFiltersParams(filters || {});

          return {
            url: `/campaign/template/all?${params.toString()}&${filtersParams}`,
            method: 'GET',
          };
        },
        providesTags: ['templates'],
        transformResponse: res => res as IPagination,
      }),
      createTemplateCampaign: builder.mutation({
        query: template => {
          return {
            url: 'campaign/template',
            method: 'POST',
            body: template,
          };
        },
        invalidatesTags: ['templates'],
      }),
      editTemplateCampaign: builder.mutation({
        query: template => ({
          url: `campaign/template/${template.id}`,
          method: 'PUT',
          body: template,
        }),
        invalidatesTags: ['templates'],
      }),
      updateTemplateCampaign: builder.mutation({
        query: template => ({
          url: `campaign/template/${template.id}`,
          method: 'PUT',
          body: template,
        }),
        invalidatesTags: ['templates'],
      }),
      copyTemplateCampaign: builder.mutation({
        query: ({ id, email }) => ({
          url: `campaign/template/copy`,
          method: 'POST',
          body: { campaign_template_id: id, email },
        }),
        invalidatesTags: ['templates'],
      }),
      deleteTemplateCampaign: builder.mutation({
        query: (id: number) => ({
          url: `campaign/template/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['templates'],
      }),
      deleteTemplateCampaignBatch: builder.mutation({
        query: (ids: number[]) => ({
          url: 'campaign/template/delete-batch',
          method: 'POST',
          body: { ids },
        }),
        invalidatesTags: ['templates'],
      }),
    }),
  });

export const {
  useGetTemplateCampaignQuery,
  useGetAllTemplateCampaignQuery,
  useCreateTemplateCampaignMutation,
  useEditTemplateCampaignMutation,
  useDeleteTemplateCampaignMutation,
  useDeleteTemplateCampaignBatchMutation,
  useCopyTemplateCampaignMutation,
} = templatesApi;
